import React from "react";

export default function Project() {
  const pjStyle = {
    backgroundColor: 'black', 
    fontFamily: 'Josefin Slab',
    color: 'white'
  };
  
  return (
    
    <section id="project" style = {pjStyle}>

      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-left">

      <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-left text-left">
      <h1 style={{fontFamily: 'cursive', textDecorationLine: 'underline'}}> Projects and Research </h1>
            <h2 class="project"> Master's Thesis </h2>
            
            <h5 class="year"> 2025-2026 </h5>
            <p class="background"> Design and Implementation of a Real-Time Hybrid Raspberry Pi-FPGA Music Emotion Recognition System </p>
            <ul>
              <li> Developed a real-time music emotion recognition system combining FPGA acceleration with Raspberry Pi ML inference. </li>
              <li> Designed a full audio processing pipeline including pre-emphasis, framing, FFT, and feature extraction. </li>
              <li> Extracted features such as MFCCs, chroma, spectral contrast, tempo, and pitch for emotion classification. </li>  
              <li> Trained and evaluated machine learning models (MLP, Random Forest, KNN) for both classification and regression. </li>
              <li> Implemented valence-arousal modeling alongside categorical emotion prediction. </li>
              <li> Built a real-time inference system with live audio streaming and low-latency processing. </li>
              <li> Designed hardware-software co-design architecture, offloading DSP tasks to FPGA and ML inference to Raspberry Pi. </li>
              <li> Analyzed trade-offs between latency, accuracy, and system complexity in embedded AI systems. </li>
              <li> Created a scalable architecture for future improvements (e.g., FPGA-based feature extraction, faster communication interfaces). </li>
            </ul>

            <h2 class="project"> Wearable Devices, Signal Processing </h2>
            
            <h5 class="year"> Spring 2026 </h5>
            <p class="background"> Real-Time PPG Heart Rate Monitoring System </p>
            <ul>
              <li> Developed a real-time physiological monitoring system using a Raspberry Pi and MAX30102 sensor to acquire raw photoplethysmography (PPG) signals. </li>
              <li> Interfaced MAX30102 biosensor with Raspberry Pi via I2C for real-time data acquisition. </li>
              <li> Designed a signal processing pipeline including DC removal, bandpass filtering (0.7–4 Hz), and peak detection for accurate heart rate estimation. </li>
              <li> Implemented real-time BPM computation using inter-beat interval analysis, achieving stable measurements (~54–56 BPM under resting conditions). </li>
              <li> Built a live terminal dashboard (PuTTY) and data logging system for continuous monitoring and analysis. </li>
              <li> Analyzed motion artifacts and sensor noise, demonstrating their impact on signal integrity and peak detection accuracy. </li>
              <li> Visualized raw and filtered signals, as well as BPM trends over time, using Python (Matplotlib, NumPy, SciPy). </li>
            </ul>

            <h2 class="project"> Rapid IoT Prototyping </h2>
            
            <h5 class="year"> Fall 2025 </h5>
            <p class="background">Smart Surveillance System with Real-Time Face Detection and Recognition </p>
            <ul>
              <li> Designed and implemented an IoT-based smart security system using the TM4C123GXL microcontroller. </li>
              <li> Integrated PIR motion detection to trigger real-time system interrupts and event handling. </li>
              <li> Developed UART communication between TM4C123 and ESP32-CAM for wireless image capture and streaming. </li>
              <li> Built a motion → capture → cloud verification → actuation pipeline for automated security response. </li>
              <li> Implemented servo motor lock control using PWM for physical access control based on authorization. </li>
              <li> Enabled face recognition via YOLO/edge-cloud processing for identity verification. </li>
              <li> Achieved low-latency performance (~40–100 ms detection, ~120–250 ms image delivery). </li>
              <li> Designed a modular embedded system architecture supporting scalability and future AI integration. </li>
              <li> Addressed hardware challenges including power stability, interrupt handling, and real-time timing constraints. </li>
            </ul>
            
            <h2 class="project"> Neural Networks </h2>
            
            <h5 class="year"> Spring 2025 </h5>
            <p class="background"> Heart Disease Prediction using Artificial Neural Networks </p>
            <ul>
              <li> Built real-time face recognition system using Python and an ESP32-CAM with live video streaming over HTTP on a Tiva-C.</li>
              <li> Trained an LBPH facial recognition model on a 200+ image dataset for multi-person identification.</li>
              <li> Integrated low-latency image processing with live video overlays for detection and recognition. </li>
            </ul>

            <h2 class="project"> Real-Time Audio and Language Processing </h2>
            
            <h5 class="year"> Winter 2024/25 </h5>
            <p class="background"> Emotion Recognition in Music</p>
            <ul>
              <li> Developed a system to classify emotions (positive, negative, neutral) from streamed audio in real time. </li>
              <li> Extracted features like tempo, pitch, and spectral contrast using LibROSA. </li>
              <li> Created a mathematical formula based on the extracted features to help determine the song's emotion. </li>
              <li> Integrated ReSpeaker HAT and Raspberry Pi for high-quality, noise-suppressed audio input.</li>
              <iframe width="560" height="315" src="https://www.youtube.com/embed/QlCLvyS1m_A?si=HkcE7SBtypIj-f9V" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </ul>

            <h2 class="project">Information Systems Capstone Project</h2>
            <h5 class="year"> Spring 2024 </h5>
            <p class="background"> House Market Prices Analytics – Phase 02 Report </p>
            <ul>
              <li> Spearheaded a comprehensive analysis of U.S. housing market trends focusing on the impact of federal interest rates and property features on housing prices using the AMES, Zillow and Redfin datasets. </li>
              <li> Utilized advanced statistical and machine learning methods including multiple linear regression and ANOVA to identify key predictors of real estate values and their implications on market dynamics. </li>
              <li> Developed predictive models to assess the influence of bedrooms, bathrooms, and square footage on house and land prices, achieving significant insights with high explanatory power. </li>
              <li> Utilized a variety of tools including Python, Excel, Google Colab, and Jupyter Notebook for data manipulation, visualization, and predictive modeling. </li>
              <li> Contributed actionable insights for real estate stakeholders to inform investment strategies and policy formulation, backed by robust statistical evidence and detailed data analysis. </li>

            </ul>

            <h2 class="project">Database Systems Senior Design Project</h2>
            <h5 class="year"> Fall 2020 </h5>
            <p class="background"> Background: For our senior design, we were tasked with designing a Youtube-like service.</p>
            <ul>
              <li> Designed an ER-model to provide a template for the database to follow </li>
              <li> Utilized the MERN Stack for the full stack implementation </li>
              <li> Implemented the model and schema for the service channel using back end </li>
              <li> Connected the server to the front end </li>
              
            </ul>
         

            <h2 class="project">Database Management Systems</h2>
            <h5 class="year"> Winter 2020 </h5>
            <p class="background"> Background: I modeled and created my own variation of an airline management system.</p>
            <ul>
              <li> Designed a logical model of the database with the ER-model </li>
              <li> Translated the ER design into PostgreSQL relational database schema </li>
              <li> Developed a client application with Java Database Connector (JDBC) </li>
              <li> Used the client application to support specific functionality and queries for the online booking system </li>
              
            </ul>
      </div>
      </div>
    </section>
  );
}